export default "__VITE_ASSET__BXqWenxm__"